// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__XDdM5","legacyBtn":"MutateMid_legacyBtn__2XweT"};